import { nextTick } from 'vue'

/**
 * 使用抖动动画的 hook
 * @param {Object} ref - 需要抖动的元素引用
 * @returns {Function} - 触发抖动的函数
 */
export function useShakeAnimation(ref) {
  const shakeWithObserver = () => {
    return new Promise((resolve) => {
      nextTick(() => {
        // 使用 IntersectionObserver 监听元素是否可见
        const observer = new IntersectionObserver(
          (entries) => {
            const [entry] = entries
            if (entry.isIntersecting) {
              // 元素可见时触发抖动
              ref.value?.shake()
              observer.disconnect()
              resolve()
            }
          },
          {
            threshold: 0.5, // 当元素有50%可见时触发
          },
        )

        // 开始观察
        if (ref.value?.$el) {
          observer.observe(ref.value.$el)
        }
      })
    })
  }

  return {
    shakeWithObserver,
  }
}
